import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 11H5.41l7.3-7.29A.996.996 0 1 0 11.3 2.3l-9.01 8.99a1 1 0 0 0 0 1.42l9 9c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L5.41 13H21c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgArrowLeft;
